import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import {
  getCookieConsent,
  CookieConsentPreferences,
} from '@/lib/utils/cookie-consent';
import CookieBanner from './CookieBanner';

export default function CookieConsentGate(): JSX.Element | null {
  const router = useRouter();
  const [consent, setConsent] = useState<CookieConsentPreferences | null>(null);
  const [hydrated, setHydrated] = useState(false);
  const [shouldShowBanner, setShouldShowBanner] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  useEffect(() => {
    setConsent(getCookieConsent());
    setShouldShowBanner(
      (process.env.NEXT_PUBLIC_STORE === 'reebelo-uk' ||
        process.env.NEXT_PUBLIC_STORE === 'reebelo-fr' ||
        process.env.NEXT_PUBLIC_STORE === 'reebelo-de' ||
        process.env.NEXT_PUBLIC_STORE === 'reebelo-es' ||
        process.env.NEXT_PUBLIC_STORE === 'reebelo-it' ||
        process.env.NEXT_PUBLIC_STORE === 'reebelo-se' ||
        process.env.NEXT_PUBLIC_STORE === 'reebelo-ie' ||
        process.env.NEXT_PUBLIC_STORE === 'reebelo-nl' ||
        process.env.NEXT_PUBLIC_STORE === 'reebelo-at' ||
        process.env.NEXT_PUBLIC_STORE === 'reebelo-be' ||
        process.env.NEXT_PUBLIC_STORE === 'reebelo-pt' ||
        process.env.NEXT_PUBLIC_STORE === 'reebelo-fi' ||
        process.env.NEXT_PUBLIC_STORE === 'reebelo-dev') &&
        !router.asPath.includes('cookie-settings'),
    );
  }, [router.asPath]);

  if (!hydrated) {
    return null;
  }

  if (consent === null && shouldShowBanner) {
    return <CookieBanner onConsentChange={() => window.location.reload()} />;
  }

  return null;
}
